import { privacyPolicyPtBr } from "./privacy-policy.pt-BR";
import { termsOfUsePtBr } from "./terms-of-use.pt-BR";
import type { LegalDocument, LegalDocumentId } from "./legal-types";

const LEGAL_DOCUMENTS: Record<LegalDocumentId, LegalDocument> = {
  privacy: privacyPolicyPtBr,
  terms: termsOfUsePtBr,
};

function getLegalDocument(documentId: LegalDocumentId): LegalDocument {
  return LEGAL_DOCUMENTS[documentId];
}

export { getLegalDocument, LEGAL_DOCUMENTS };
